import isNil from 'lodash/isNil'
import isString from 'lodash/isString'

export default function (title) {
  if (isNil(title) || !isString(title) || title === '') {
    console.log('Invalid title.')
    return null
  }

  const titleId = title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '')
    .trim()

  if (titleId === '') {
    console.error('Invalid title value - empty after conversion to id.')
    return null
  }
  // console.log('title', title, 'id', id)
  return titleId
}
